/**
 * AWS regions within which a court system's assets (TRMs, FLS files, search indexes, etc) may be stored.
 * Supported values vary depending on environment
 * (see https://github.com/FTRLabs/ftr-cfn-userdata/blob/develop/terraform/deploy/main.tf)
 */
export var Region;
(function (Region) {
    // Canada (Central)
    Region["ca-central-1"] = "ca-central-1";
    // US West (Oregon)
    Region["us-west-2"] = "us-west-2";
    // Asia Pacific (Sydney)
    Region["ap-southeast-2"] = "ap-southeast-2";
    // EU (London)
    Region["eu-west-2"] = "eu-west-2";
})(Region || (Region = {}));
/**
 * All regions within which court systems store their assets.
 * @see Region
 */
export const ALL_REGIONS = Object.keys(Region).map(key => Region[key]);
